export default "__VITE_ASSET__DMCHwnnZ__"